import { type Property } from "@/types/property";
import { useState } from "react";
import { type Booking } from "../useBookings";

export const useBookingState = () => {
  const [selectedBooking, setSelectedBooking] = useState<Booking | null>(null);
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [showBookingFormModal, setShowBookingFormModal] = useState(false);
  const [selectedDateForReservation, setSelectedDateForReservation] =
    useState<Date | null>(null);
  const [selectedPropertyForReservation, setSelectedPropertyForReservation] =
    useState<string>("");

  const handleBookingClick = (booking: Booking) => {
    setSelectedBooking(booking);
    setShowBookingModal(true);
  };

  const handleCancelBooking = () => setShowBookingModal(false);

  const handleBookingCreated = () => {
    setShowBookingFormModal(false);
    setSelectedDateForReservation(null);
    setSelectedPropertyForReservation("");
    // Limpiar reservación seleccionada al completar creación
    setSelectedBooking(null);
  };

  const handleAddReservation = (date: Date, property: Property) => {
    // Limpiar cualquier reservación seleccionada para asegurar modo creación
    setSelectedBooking(null);
    setSelectedDateForReservation(date);
    setSelectedPropertyForReservation(property.id);
    setShowBookingFormModal(true);
  };

  return {
    selectedBooking,
    showBookingModal,
    showBookingFormModal,
    selectedDateForReservation,
    selectedPropertyForReservation,
    setShowBookingModal,
    setShowBookingFormModal,
    handleBookingClick,
    handleCancelBooking,
    handleBookingCreated,
    handleAddReservation,
  };
};
